<!--
사용자 > 폐기대상 페이지에서 사용되는 일괄작업
 - 컨트롤러를 따로 사용하지 않고, 컨트롤러의 기능을 mixin 상속받음
------------------------------------
-->
<template>
    <div
        class="wrapper"
        :uk-sticky="onSticky && itemCheckedCount > 0"
    >
        <div class="uk-flex uk-flex-between uk-flex-bottom">
            <button
                class="uk-button uk-button-primary uk-margin-right"
                type="button"
                :disabled="disabled"

                @click="$refs['destroy-req'].jobInit()"
            >
                <i class="material-icons">edit</i>
                선택상품 폐기요청
            </button>

            <!-- 선택개수안내 -->
            <div class="selected-msg" v-show="itemCheckedCount > 0" v-html="itemCheckedInfo"></div>

            <!-- 선택된 아이템 없음 -->
            <div class="no-selected-msg" v-show="itemCheckedCount === 0">
                {{ batch.item_checked_nothing_msg }}
            </div>

        </div>


        <!-- 폐기요청 기능 -->
        <destroy-req
            ref="destroy-req"
            :batch="batch"
            :csrfToken="csrfToken"
        ></destroy-req>
    </div>

</template>

<script>
    import checkedCountable from '../../checked-countable';
    import stickiable from '../../stickable';

    export default {
        mixins: [
            checkedCountable,
            stickiable,
        ],
        components: {
            'destroy-req': require('../prod/destroy-req.vue').default,
        },
        props: {
            /**
             * 일괄기능 공유data (상세정의는 컨트롤러 참고)
             */
            batch: Object,

            // csrf-token
            csrfToken: String,

            // 지역ID
            regionId: Number,
        },
        data: function () {

            return {
            };
        },
        computed: {
            // 작업 버튼 비활성화 여부
            disabled() {
                // 선택된 아이템없으면 비활성화
                return this.batch.checked_item_count === 0;
            },
        },
        methods: {
        }
    }
</script>

<style lang="scss" scoped>
    .wrapper {
        background-color: #fff;
        border-bottom: 1px solid #ddd;
        padding-bottom: 0.5rem;
    }

</style>